// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"80":"6ab6c6e84c14cf76","186":"e19f41f0d6d2835b"}[chunkId] + ".css";
};